<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzBackIcon nzBack nzTitle="Configurações" nzSubtitle=" - Atualização de suas configurações.">
    </nz-page-header>

    <form nz-form [formGroup]="configuracaoForm" autocomplete="off" (ngSubmit)="onSubmit()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="5">
                <nz-form-item>
                    <nz-form-label nzRequired>CNPJ:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="cnpj" mask="00.000.000/0000-00" formControlName="cnpj" placeholder="00.000.000/0000-00" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="9">
                <nz-form-item>
                    <nz-form-label nzRequired>Razão Social:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="razao_social" maxlength="150" formControlName="razao_social" placeholder="Razão Social" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="10">
                <nz-form-item>
                    <nz-form-label nzRequired>Nome Fantasia:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="nome_fantasia" maxlength="150" formControlName="nome_fantasia" placeholder="Nome Fantasia" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="7">
                <nz-form-item>
                    <nz-form-label nzRequired>E-mail:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input type="email" name="email" maxlength="45" formControlName="email" placeholder="exemplo@exemplo.com.br" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="5">
                <nz-form-item>
                    <nz-form-label>Telefone:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="telefone" mask="(00) 00000-0000 || (00) 0000-0000" formControlName="telefone" placeholder="(00) 0000-0000" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="5">
                <nz-form-item>
                    <nz-form-label nzRequired>Celular:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="celular" formControlName="celular" placeholder="(00) 00000-0000" mask="(00) 00000-0000 || (00) 0000-0000" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="7">
                <nz-form-item>
                    <nz-form-label>Site:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input type="text" name="site" maxlength="255" formControlName="site" placeholder="https://exemplo.com.br" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" nzBlock>Salvar</button>
            </div>
        </div>
    </form>
</div>